<template>
  <md-app style="width:100%">
    <md-app-drawer md-permanent="full" style="pointer-events: auto;">
      <md-toolbar class="md-transparent" md-elevation="1">
        <p v-if="panoramaTour">{{panoramaTour.getName()}}</p>
      </md-toolbar>
      <md-list class="md-double-line">
        <md-subheader>Situation</md-subheader>
        <md-list-item>
          <div class="md-list-item-text">
            <span v-if="currentSituation">{{currentSituation.getName()}}</span>
            <span>Name</span>
          </div>
        </md-list-item>

        <md-divider></md-divider>

        <md-subheader>User</md-subheader>

        <md-list-item>
          <div class="md-list-item-text">
            <span>{{ localUser.getID() }} </span>
            <span>ID </span>
          </div>
        </md-list-item>

        <md-list-item>
          <div class="md-list-item-text">
            <input v-model="acronym"/>
            <span>Acronym</span>
          </div>
        </md-list-item>

        <md-list-item>
          <div class="md-list-item-text">
            <span>{{ localUser.getRotation() }} </span>
            <span>Rotation </span>
          </div>
        </md-list-item>

        <md-subheader>Users</md-subheader>

        <md-list-item>
          <button v-on:click="addUser">Add User</button>
        </md-list-item>

        <md-list-item v-for="u in remoteUsersInCurrentSituation" :key="u.getID()">
          {{ u.getID() }}
        </md-list-item>
      </md-list>

      <md-list-item>
        <button v-on:click="playSound">Play</button>
      </md-list-item>
      <md-list-item>
        <button v-on:click="pauseSound">Pause</button>
      </md-list-item>
      <md-list-item>
        <button v-on:click="jumpTo">JumpTo</button>
      </md-list-item>
    </md-app-drawer>
  </md-app>
</template>

<style>
</style>

<script>
    import { mapGetters } from 'vuex'
    import {User} from "@/store/flux360/UserDataTypes";

    export default {
        data: () => ({
        }),
        computed: {
            ...mapGetters(['currentPrefabs', 'currentSituation', 'localUser', 'panoramaTour', 'remoteUsersInCurrentSituation', 'currentSounds']),
            acronym: {
                get() {
                    return this.$store.getters.localUser.getAcronym();
                },
                set( value ) {
                    this.$store.commit('updateUser', { id: this.localUser.getID(), acronym: value });
                }
            }
        },
        methods: {
          addUser() {
            const u = new User();
            if( this.localUser ) {
              u.setPosition( this.localUser.getPosition() );
              u.setGazePosition( this.localUser.getGazePosition() );
              u.setCursorPosition( this.localUser.getCursorPosition() );
              u.setRotation( this.localUser.getRotation() );
              u.setCurrentSituationID( this.localUser.getCurrentSituationID() );
              u.setAcronym("User"+Math.floor(Math.random() * 100));
              // let color = (Math.random() * 0xfffff * 1000000).toString(16);
              // u.setColor('#' + color.slice(0, 6));
              let r = 0;
              let g = 0;
              let b = 0;
              while(r+g+b == 0 || r+g+b < 300 ){
                r = Math.floor(Math.random()*255).toString(16);
                g = Math.floor(Math.random()*255).toString(16);
                b = Math.floor(Math.random()*255).toString(16);
              }
              if(r.length == 1) r = ("0"+r).toString(16);
              if(g.length == 1) g = ("0"+g).toString(16);
              if(b.length == 1) b = ("0"+b).toString(16);
              console.log("Adding user with position and rotation: " + JSON.stringify(u.getPosition()) + " / " + JSON.stringify(u.getRotation()) );
              console.log("And color " + u.getColor() );
            }
            this.$store.commit('addUser', u );
          },
          playSound(){
            this.currentPrefabs.forEach( x => {         
              if(x.runtimeState!=null)
                x.runtimeState.requestPlay("this.localUser");
            });
           //console.log ("Pausing Sound " + {this.currentSounds[0].getName()} );
            
          },
          pauseSound(){           
            this.currentPrefabs.forEach( x => {         
              if(x.runtimeState!=null)
                x.runtimeState.requestPause("this.localUser");
            });
           //console.log ("Pausing Sound " + {this.currentSounds[0].getName()} );
            
          },
          jumpTo(){
            this.currentPrefabs.forEach( x => {
              if(x.runtimeState!=null)
                x.runtimeState.requestJumpToTimePosition("this.localUser", 100);
            });
          }
        },
        watch: {
        },
    }
</script>